import { listPortalOrders, type PortalOrderRow } from '@api/b2bPortal';
import PageHeader from '@components/common/PageHeader';
import { DataSheet, type DataSheetColumn } from '@components/ui/DataSheet';
import { Button } from '@mantine/core';
import { ButtonVariant } from '@providers/Mantine/mantineTheme';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router';
import { Pill } from '../shared';
import { formatDay, money } from '../utils';


const PortalOrders: React.FC = () => {
    const navigate = useNavigate();
    const { data: orders = [], isLoading } = useQuery({ queryKey: ['portal-orders'], queryFn: listPortalOrders });
    const columns: DataSheetColumn<PortalOrderRow>[] = [
        { key: 'purchaseOrderId', header: 'Order', width: 160, sticky: true },
        { key: 'date', header: 'Date', width: 120, render: (v: string) => formatDay(v) },
        { key: 'customerReference', header: 'Your PO', width: 160, render: (v: string | null) => v ?? '—' },
        { key: 'status', header: 'Status', width: 170, render: (v: string) => <Pill label={v} /> },
        { key: 'total', header: 'Value', width: 130, align: 'right', render: (v: number) => money(v) },
    ];
    return (
        <div className="flex h-full w-full flex-col gap-6 page-shell">
            <PageHeader
                icon="📦"
                title="My orders"
                actions={
                    <Button variant={ButtonVariant.ACTION} onClick={() => navigate('/portal/orders/new')}>
                        New order
                    </Button>
                }
            />
            <DataSheet<PortalOrderRow>
                title="Orders"
                subtitle={`${orders.length} orders`}
                data={orders}
                columns={columns}
                getRowKey={(r) => r.purchaseOrderId}
                isLoading={isLoading}
                onRowClick={(r) => navigate(`/portal/orders/${encodeURIComponent(r.purchaseOrderId)}`)}
                maxHeight="auto"
                emptyState="No orders yet."
            />
        </div>
    );
};

export default PortalOrders;
